'use strict';

function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

var _typeof = 'function' == typeof Symbol && 'symbol' == _typeof2(Symbol.iterator) ? function (obj) {
  return _typeof2(obj);
} : function (obj) {
  return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : _typeof2(obj);
};
/*global define*/


var _html = require('linkifyjs/html'),
    _html2 = _interopRequireDefault(_html);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

(function () {
  function a(b, c) {
    b.innerHTML = (0, _html2.default)(b.innerHTML, c.value);
  }

  'object' == ('undefined' == typeof exports ? 'undefined' : _typeof(exports)) ? module.exports = a : 'function' == typeof define && define.amd ? define([], function () {
    return a;
  }) : window.Vue && window.Vue.directive('linkified', a);
})();